import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import "../../config/i18n";
import { googleTranslate } from "../../config/googleTranslate";
import ImageZoom from "react-medium-image-zoom";
import { NavLink } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Loader from "react-loader-spinner";
import axios, { post } from "axios";
import "moment-timezone";
import Moment from "react-moment";
import ls from "local-storage";
import { options } from "../../config/options";
import socketIOClient from "socket.io-client";
import { CAPTURE_EVENT } from "../../Services/PosthogService";

Moment.globalFormat = "D MMM YYYY hh mm A";
const cryptLib = require("@skavinvarnan/cryptlib");
const encryptKey = "crypt@123";
var timerId = undefined;
var typingTrack = 0;
const API_KEY = "AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ";

class MessageNew extends Component {
  constructor(props) {
    super(props);
    this.onChangemessage = this.onChangemessage.bind(this);
    this.onSendmessage = this.onSendmessage.bind(this);
    this.reportToggle = this.reportToggle.bind(this);
    this.onClearchat = this.onClearchat.bind(this);
    this.onDeletemsg = this.onDeletemsg.bind(this);
    this.onBlock = this.onBlock.bind(this);
    this.onUnfriend = this.onUnfriend.bind(this);
    this.groupData = this.groupData.bind(this);
    this.translateChat = this.translateChat.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleKeyUp = this.keyUpHandler.bind(this, "msgInput");
    this.fileUpload = this.fileUpload.bind(this);
    this.SafetyLink = this.SafetyLink.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.boxMouseOverHandler = this.boxMouseOverHandler.bind(this);
    this.boxMouseLeaveHandler = this.boxMouseLeaveHandler.bind(this);
    this.displayData = [];
    this.state = {
      new_message: "true",
      receiver: {},
      dropdownOpen: false,
      chats: [],
      user_details: "",
      message: "",
      response: false,
      endpoint: "https://www.moulook.com:8092",
      showdata: this.displayData,
      postVal: "",
      loading: "d-none",
      images: "",
      errors: {},
      chat_image: "",
      modal1: false,
      activeTab: "1",
      blocked_by_me: "",
      block: "",
      blocked_popup: "",
      modal2: false,
      limit: 8,
      loadmore: "none",
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue"),
      modal3: false,
      api_url: localStorage.getItem("api_url"),
      chatId: "",
      languageCodes: [],
      language: "",
      curr_user_id: "",
      scrollDownFix: false,
      loaderDisplay: false,
      delmsg: false,
      delete_id: 0,
      modal5: false,
      msgid: 0,
      //instantChatTrans: "",
    };

    const socket = socketIOClient(this.state.endpoint);
    const {
      match: { params },
    } = this.props;

    socket.on("broad", (data) => {
      this.setState({ loading: "d-none" });
      // console.log('SENDER ID'+data.sender_id+ " // "+params.userId);
      if (data.sender_id === params.userId) {
        this.addMsg(data);
      }
    });

    socket.on("delbroad", (data) => {
      this.setState({ loading: "d-none" });
      console.log("SENDER ID" + data.sender_id + " // " + params.userId);
      if (data.sender_id === params.userId) {
        var chat_arr = this.state.chats;
        var chat_index = chat_arr.findIndex((x) => x.id == data.message_id);
        console.log("chatindex=" + chat_index);
        chat_arr[chat_index].delete = 1;
        chat_arr[chat_index].deleted_by = data.deleted_by;
        this.setState({
          chats: chat_arr,
        });
      }
    });
    socket.on("receivetyping", (data) => {
      // console.log(data.message+' || '+data.receiver_id+' '+JSON.parse(localStorage.getItem('session_userid')));

      if (data.message === "type") {
        if (
          data.receiver_id ===
          JSON.parse(localStorage.getItem("session_userid"))
        ) {
          this.setState({ loading: "loadingTxts" });
        }
      } else {
        this.setState({ loading: "d-none" });
      }
    });

    socket.on("receiveuntyping", (data) => {
      //console.log(data.receiver_id+' '+JSON.parse(localStorage.getItem('session_userid')));
      if (
        data.receiver_id === JSON.parse(localStorage.getItem("session_userid"))
      ) {
        this.setState({ loading: "d-none" });
      }
    });
  }

  //chat translation
  changeHandler = (language) => {
    localStorage.setItem("chatTransLang", JSON.stringify(language));
    this.setState({
      scrollDownFix: true,
      language: language,
    });
  };
  translateChat(question, language, index) {
    this.setState({
      scrollDownFix: true,
    });
    let temparray = [...this.state.chats];
    if (question && language) {
      googleTranslate.translate(question, language, (err, translation) => {
        if (translation.translatedText) {
          temparray[index].message = translation.translatedText;
          this.setState({
            chats: temparray,
          });
        }
      });
    }
  }
  groupData(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  addMsg(data) {
    // Append the message to the component state
    console.log("full data");
    console.log(data);

    const { t } = this.props;
    const chats = this.state.chats;
    var months = [
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ];
    var d = new Date(parseInt(data.message.chatTime) * 1000);
    /** date */
    var dt = d.getDate();
    var mon = months[d.getMonth()];
    var yr = d.getFullYear();
    var mydate = dt + ", " + t(mon) + " " + yr;

    /** time */
    // var hours = d.getHours();
    // var minutes = d.getMinutes();
    // var ampm = hours >= 12 ? 'PM' : 'AM';

    var timestamp = parseInt(data.message.chatTime); // Ensure it's an integer
    if (timestamp.toString().length === 10) {
      timestamp *= 1000; // Convert seconds to milliseconds if needed
    }
    var londonDate = new Date(timestamp);
    var options = {
      timeZone: "Europe/London",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    var londonTimeFormatted = new Intl.DateTimeFormat(
      "en-US",
      options
    ).formatToParts(londonDate);
    let hours, minutes, seconds, period;
    londonTimeFormatted.forEach(({ type, value }) => {
      if (type === "hour") hours = value;
      if (type === "minute") minutes = value;
      if (type === "second") seconds = value;
      if (type === "dayPeriod") period = value.toUpperCase(); // Capitalize AM/PM
    });

    var time = `${hours}:${minutes}:${seconds} ${period}`;

    var transLangCode = "en";
    var transtext = "";
    if (data.message.type === "text") {
      // transtext = cryptLib.decryptCipherTextWithRandomIV(data.message.message,encryptKey);
      transtext = data.message.message;

      if (JSON.parse(localStorage.getItem("chatTransLang"))) {
        transLangCode =
          JSON.parse(localStorage.getItem("chatTransLang")).length === 4
            ? "en"
            : JSON.parse(localStorage.getItem("chatTransLang"));
      }

      if (transLangCode === "en") {
        const recmsg = {
          message: transtext,
          sender_id: data.sender_id,
          receiver_id: data.receiver_id,
          image: "",
          date: mydate,
          delete: 0,
          time: time,
          id: data.message.id,
        };
        chats.push(recmsg);
        this.setState({ chats });
        this.setState({
          scrollDownFix: false,
        });
      } else {
        googleTranslate.translate(
          transtext,
          transLangCode,
          (err, translation) => {
            if (translation.translatedText) {
              if (
                data.sender_id ===
                JSON.parse(localStorage.getItem("session_userid"))
              ) {
                const recmsg = {
                  message: transtext,
                  sender_id: data.sender_id,
                  receiver_id: data.receiver_id,
                  image: "",
                  date: mydate,
                  delete: 0,
                  time: time,
                  id: data.message.id,
                };
                chats.push(recmsg);
                this.setState({ chats });
                this.setState({
                  scrollDownFix: false,
                });
              } else {
                const recmsg = {
                  message: translation.translatedText,
                  sender_id: data.sender_id,
                  receiver_id: data.receiver_id,
                  image: "",
                  date: mydate,
                  delete: 0,
                  time: time,
                  id: data.message.id,
                };
                chats.push(recmsg);
                this.setState({ chats });
                this.setState({
                  scrollDownFix: false,
                });
              }
            }
          }
        );
      }

      // googleTranslate.translate(transtext, transLangCode, (err, translation) => {
      //     if (translation.translatedText) {
      //         if (data.sender_id === JSON.parse(localStorage.getItem('session_userid'))) {
      //             const recmsg = {
      //                 "message": transtext,
      //                 "sender_id": data.sender_id,
      //                 "receiver_id": data.receiver_id,
      //                 "image": "",
      //                 "date": mydate,
      //                 "delete": 0,
      //                 "time": time,
      //                 "id": data.message.id
      //             }
      //             chats.push(recmsg);
      //             this.setState({ chats });
      //             this.setState({
      //                 scrollDownFix: false,
      //             })
      //         } else {
      //             const recmsg = {
      //                 "message": translation.translatedText,
      //                 "sender_id": data.sender_id,
      //                 "receiver_id": data.receiver_id,
      //                 "image": "",
      //                 "date": mydate,
      //                 "delete": 0,
      //                 "time": time,
      //                 "id": data.message.id
      //             }
      //             chats.push(recmsg);
      //             this.setState({ chats });
      //             this.setState({
      //                 scrollDownFix: false,
      //             })
      //         }
      //     } else {
      //         const recmsg = {
      //             "message": transtext,
      //             "sender_id": data.sender_id,
      //             "receiver_id": data.receiver_id,
      //             "image": "",
      //             "date": mydate,
      //             "delete": 0,
      //             "time": time,
      //             "id": data.message.id
      //         }
      //         chats.push(recmsg);
      //         this.setState({ chats });
      //         this.setState({
      //             scrollDownFix: false,
      //         })
      //     }
      // });
    } else if (data.message.type === "image") {
      const recmsg = {
        message: "",
        sender_id: data.sender_id,
        receiver_id: data.receiver_id,
        upload_image: data.message.upload_image,
        date: mydate,
        delete: 0,
        time: time,
        id: data.message.id,
      };
      chats.push(recmsg);
      this.setState({ chats });
    } else if (data.message.type === "gif") {
      transtext = "Gif Images";
      if (JSON.parse(localStorage.getItem("chatTransLang"))) {
        transLangCode =
          JSON.parse(localStorage.getItem("chatTransLang")).length === 4
            ? "en"
            : JSON.parse(localStorage.getItem("chatTransLang"));
      } else {
        transLangCode = "en";
      }
      googleTranslate.translate(
        transtext,
        transLangCode,
        (err, translation) => {
          if (translation.translatedText) {
            const recmsg = {
              message: translation.translatedText,
              sender_id: data.sender_id,
              receiver_id: data.receiver_id,
              image: "",
              date: mydate,
              delete: 0,
              time: time,
              id: data.message.id,
            };
            chats.push(recmsg);
            this.setState({ chats });
          } else {
            const recmsg = {
              message: transtext,
              sender_id: data.sender_id,
              receiver_id: data.receiver_id,
              image: "",
              date: mydate,
              delete: 0,
              time: time,
              id: data.message.id,
            };
            chats.push(recmsg);
            this.setState({ chats });
            this.setState({
              scrollDownFix: false,
            });
          }
        }
      );
    } else if (data.message.type === "audio_msg") {
      transtext = "Audio Message";
      if (JSON.parse(localStorage.getItem("chatTransLang"))) {
        transLangCode =
          JSON.parse(localStorage.getItem("chatTransLang")).length === 4
            ? "en"
            : JSON.parse(localStorage.getItem("chatTransLang"));
      } else {
        transLangCode = "en";
      }
      googleTranslate.translate(
        transtext,
        transLangCode,
        (err, translation) => {
          if (translation.translatedText) {
            const recmsg = {
              message: translation.translatedText,
              sender_id: data.sender_id,
              receiver_id: data.receiver_id,
              image: "",
              date: mydate,
              delete: 0,
              time: time,
              id: data.message.id,
            };
            chats.push(recmsg);
            this.setState({ chats });
          } else {
            const recmsg = {
              message: transtext,
              sender_id: data.sender_id,
              receiver_id: data.receiver_id,
              image: "",
              date: mydate,
              delete: 0,
              time: time,
              id: data.message.id,
            };
            chats.push(recmsg);
            this.setState({ chats });
            this.setState({
              scrollDownFix: false,
            });
          }
        }
      );
    }
    // console.log("addMsg(data): ", this.state.chats)
  }
  //  Scroll to Bottom Function
  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView();
  };
  componentDidUpdate() {
    if (this.state.scrollDownFix === false) this.scrollToBottom();
  }
  componentDidMount() {
    /*console.log("sadasdasdasd");
        console.log(JSON.parse(localStorage.getItem('chatTransLang')));*/
    // load all of the language options from Google Translate to your app state

    // googleTranslate.getSupportedLanguages("en", function(err, languageCodes) {

    //   getLanguageCodes(languageCodes); // use a callback function to setState
    // });
    // const getLanguageCodes = languageCodes => {
    //   this.setState({ languageCodes });
    // };

    axios({
      method: "get",
      url: "https://translation.googleapis.com/language/translate/v2/languages?key=AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ&target=en",
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      //console.log("mytrans"+JSON.stringify(res));
      var result = JSON.stringify(res);
      const languageCodes = JSON.parse(result);

      // const languageCodes = JSON.stringify(languageCodess.data.data.languages,null,4);
      console.log(languageCodes.data.data.languages);
      this.setState({ languageCodes: languageCodes.data.data.languages });
    });

    this.setState({
      loader: "loder-icon",
      curr_user_id: JSON.parse(localStorage.getItem("session_userid")),
    });
    setTimeout(() => {
      this.setState({
        profilespace: "",
        loader: "none",
      });
    }, 2000);
    /* const { endpoint } = this.state;
        const socket = socketIOClient(endpoint);
       socket.on('broad',  (data)=> {
            console.log(data);
            this.setState({ response: data });
            this.append_receiver();
        }); */
    //socket.on("FromAPI", data => this.setState({ response: data }));
    const {
      match: { params },
    } = this.props;
    //console.log("params", params)

    this.setState({
      chatId: params.chatId,
    });

    var dataProfile = new FormData();
    dataProfile.set("user_id", params.userId);
    dataProfile.set("chat_id", params.chatId);
    dataProfile.set(
      "own_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    dataProfile.set("language", this.state.langKey);

    axios({
      method: "post",
      url: this.state.api_url + "webprofile",
      data: dataProfile,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const user_details = res.data.result;
      if (res.data === 0) {
        this.props.history.push("/app/Message");
        //alert("Access denied!");
      }
      // console.log("user_detail_full", user_details)
      this.setState({
        user_details: user_details,
      });
    });
    var data_block = new FormData();
    data_block.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    data_block.set("chatid", params.chatId);
    data_block.set("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "blockstatus",
      data: data_block,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const details = res.data;
      //console.log("bloc", res.data);
      this.setState({
        block: details.block,
        blocked_by_me: details.blocked_by_me,
      });
      // alert(this.state.blocked_by_me)
    });

    var messages = new FormData();
    messages.set("user_id", JSON.parse(localStorage.getItem("session_userid")));
    messages.set("chat_id", params.chatId);
    messages.set("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webgetchatmessage",
      data: messages,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const data = res.data;
      if (res.data.status !== "false") {
        this.setState({
          chats: data.chats,
          new_message: data.is_first_message?data.is_first_message:"true",
          receiver: data.receiver,
        });
      }
    });

    const socket = socketIOClient(this.state.endpoint);
    socket.emit("join", {
      join_id: JSON.parse(localStorage.getItem("session_userid")),
    });
  }

  SafetyLink() {
    this.props.history.push("/app/Help/2");
  }

  closeModal(tabId) {
    this.setState({
      [tabId]: false,
    });
  }
  showModal(modal) {
    this.setState({
      [modal]: true,
    });
    // console.log(this.state);
  }
  showModal2(modal) {
    this.setState({
      [modal]: true,
      activeTab: "2",
    });
  }
  showModal3(modal) {
    this.setState({
      [modal]: true,
      activeTab: "3",
    });
  }

  showModal5(modal, id) {
    localStorage.setItem("delete_id", id);
    this.setState({
      [modal]: true,
      activeTab: "5",
      scrollDownFix: true,
    });
  }

  keyUpHandler(refName, e) {
    const keycode = e.keyCode;
    const {
      match: { params },
    } = this.props;
    const { endpoint } = this.state;
    const socket = socketIOClient(endpoint);

    if (typingTrack === 0 && keycode !== 13) {
      socket.emit("typing", {
        chatid: params.chatId,
        sender_id: JSON.parse(localStorage.getItem("session_userid")),
        receiver_id: params.userId,
        message: "type",
      });
      typingTrack = 1;
    }

    if (keycode === 13) {
      this.onSendmessage();
      return false;
    }

    if (typingTrack === 1) {
      clearTimeout(timerId);
    }

    if (keycode !== 13) {
      timerId = setTimeout(function () {
        typingTrack = 0;

        socket.emit("typing", {
          chatid: params.chatId,
          sender_id: JSON.parse(localStorage.getItem("session_userid")),
          receiver_id: params.userId,
          message: "untype",
        });
        // clearTimeout(timerId);
      }, 2000);
    }
  }

  onChangemessage(e) {
    typingTrack = 0;
    clearTimeout(timerId);
    this.setState({
      message: e.target.value,
    });
  }

  onSendmessage() {
    typingTrack = 0;
    clearTimeout(timerId);

    this.setState({
      message: "",
      scrollDownFix: false,
    });

    const {
      match: { params },
    } = this.props;
    var messageInput = document.getElementById("messageinput");
    var newmsg = messageInput.value;
    messageInput.value = "";
    if (newmsg.trim() !== "") {
      var send_message = new FormData();
      send_message.set(
        "sender_id",
        JSON.parse(localStorage.getItem("session_userid"))
      );
      send_message.set("chat_id", params.chatId);
      send_message.set("receiver_id", params.userId);
      send_message.set("message", newmsg);
      send_message.set("chat_time", "");
      send_message.set("upload_image", "");
      send_message.set("language", this.state.langKey);

      const curtime = Math.floor(Date.now() / 1000).toString();
      this.scrollToBottom();

      axios({
        method: "post",
        url: this.state.api_url + "websendmessage",
        data: send_message,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      }).then((res) => {
        if (res.data.status !== "false") {
          if (this.state.new_message == "true") {
            let new_message_properties = {
              properties: {
                chat_id: params.chatId,
                sender_id: JSON.parse(localStorage.getItem("session_userid")),
                sender_email: this.state.user_details.email,
                sender_name: this.state.user_details.user_name,
                receiver_id: params.userId,
                receiver_email: this.state.receiver.email
                  ? this.state.receiver.name
                  : "",
                receiver_name: this.state.receiver.name
                  ? this.state.receiver.name
                  : "",
                message_type: "text",
              },
            };

            this.setState({
              new_message: "false",
            });
          }

          let message_properties = {
            properties: {
              chat_id: params.chatId,
              sender_id: JSON.parse(localStorage.getItem("session_userid")),
              sender_email: this.state.user_details.email,
              sender_name: this.state.user_details.user_name,
              receiver_id: params.userId,
              receiver_email: this.state.receiver.email
                ? this.state.receiver.name
                : "",
              receiver_name: this.state.receiver.name
                ? this.state.receiver.name
                : "",
              message_type: "text",
            },
          };

          CAPTURE_EVENT("message_sent", message_properties);

          if (this.state.new_message == "true") {
            CAPTURE_EVENT("message_after_match", message_properties);
            this.setState({
              new_message: "false",
            });
          }

          var messages = new FormData();
          messages.set(
            "user_id",
            JSON.parse(localStorage.getItem("session_userid"))
          );
          messages.set("chat_id", params.chatId);
          messages.set("language", this.state.langKey);
          axios({
            method: "post",
            url: this.state.api_url + "webgetchatmessage",
            data: messages,
            config: { headers: { "Content-Type": "multipart/form-data" } },
          }).then((res) => {
            const data = res.data;
            if (res.data.status !== "false") {
              this.setState({
                chats: data.chats,
                new_message: data.is_first_message?data.is_first_message:"true",
                receiver: data.receiver,
              });
            }
          });

          this.addMsg({
            chatid: params.chatId,
            sender_id: JSON.parse(localStorage.getItem("session_userid")),
            receiver_id: params.userId,
            transLanguage: JSON.parse(localStorage.getItem("chatTransLang")),
            message: {
              message: newmsg,
              upload_image: "",
              userName: "",
              userImage: "",
              chatTime: curtime,
              type: "text",
              id: res.data.id,
            },
          });

          const { endpoint } = this.state;
          const socket = socketIOClient(endpoint);
          socket.emit("message", {
            chatid: params.chatId,
            sender_id: JSON.parse(localStorage.getItem("session_userid")),
            receiver_id: params.userId,
            transLanguage: JSON.parse(localStorage.getItem("chatTransLang")),
            message: {
              message: newmsg,
              upload_image: "",
              userName: "",
              userImage: "",
              chatTime: curtime,
              type: "text",
              id: res.data.id,
            },
          });
        } else {
          this.props.history.push("/app/Message");
        }
      });
    } else {
      let errors = {};
      errors["uploadimage"] = "Please enter the message";
      this.setState({
        errors: errors,
        suc_msg: "errorMsg floatingAlerts1",
      });
      setTimeout(() => {
        this.setState({
          suc_msg: "errorMsghide",
        });
      }, 2000);
    }
  }

  componentWillMount() {}

  onFormSubmit(e) {
    this.fileUpload(this.state.images);
  }
  onChange(e) {
    var sFileName = e.target.files[0].name;
    this.setState({
      file: URL.createObjectURL(e.target.files[0]),
    });

    let files = e.target.files || e.dataTransfer.files;
    var _validFileExtensions = [
      ".png",
      ".jpg",
      ".jpeg",
      ".gif",
      ".JPG",
      ".PNG",
      ".JPEG",
      ".GIF",
    ];
    if (!files.length) return;
    else {
      var blnValid = false;
      for (var j = 0; j < _validFileExtensions.length; j++) {
        var sCurExtension = _validFileExtensions[j];
        if (
          sFileName
            .substr(
              sFileName.length - sCurExtension.length,
              sCurExtension.length
            )
            .toLowerCase() === sCurExtension.toLowerCase()
        ) {
          blnValid = true;
          break;
        }
      }

      if (!blnValid) {
        alert("Sorry, Invalid file!");
        return false;
      }

      this.createImage(files[0]);
    }
  }
  createImage(file) {
    //console.log(file)
    let reader = new FileReader();
    reader.onload = (e) => {
      //console.log(e.target.result);
      this.setState({
        images: e.target.result,
      });
    };
    reader.readAsDataURL(file);
    setTimeout(() => {
      this.onFormSubmit();
    }, 2000);
  }
  fileUpload(images) {
    const {
      match: { params },
    } = this.props;
    let errors = {};
    this.setState({
      loader: "loder-icon",
    });
    if (this.state.images === null || this.state.images === "") {
      errors["uploadimage"] = "Select a image";
      this.setState({
        errors: errors,
        suc_msg: "errorMsg floatingAlerts1",
      });
      setTimeout(() => {
        this.setState({
          suc_msg: "errorMsghide",
        });
      }, 2000);
    } else {
      this.setState({
        loaderDisplay: true,
      });
      const url = this.state.api_url + "uploadimagechat";
      const formData = {
        file: this.state.images,
        language: this.state.langKey,
      };

      return post(url, formData).then((res) => {
        console.log(res.data);
        if (res.data.status === "true") {
          this.setState({
            loaderDisplay: false,
          });
          const { endpoint } = this.state;
          const socket = socketIOClient(endpoint);

          const curtime = Math.floor(Date.now() / 1000).toString();

          var send_message = new FormData();
          send_message.set(
            "sender_id",
            JSON.parse(localStorage.getItem("session_userid"))
          );
          send_message.set("chat_id", params.chatId);
          send_message.set("receiver_id", params.userId);
          send_message.set("message", "");
          send_message.set("chat_time", "");
          send_message.set("upload_image", res.data.image_name);
          send_message.set("language", this.state.langKey);
          axios({
            method: "post",
            url: this.state.api_url + "websendmessage",
            data: send_message,
            config: { headers: { "Content-Type": "multipart/form-data" } },
          }).then((result) => {
            if (result.data.status !== "false") {
              let message_properties = {
                properties: {
                  chat_id: params.chatId,
                  sender_id: JSON.parse(localStorage.getItem("session_userid")),
                  sender_email: this.state.user_details.email,
                  sender_name: this.state.user_details.user_name,
                  receiver_id: params.userId,
                  receiver_email: this.state.receiver.email
                    ? this.state.receiver.name
                    : "",
                  receiver_name: this.state.receiver.name
                    ? this.state.receiver.name
                    : "",
                  message_type: "text",
                },
              };

              CAPTURE_EVENT("message_sent", message_properties);

              if (this.state.new_message == "true") {
                CAPTURE_EVENT("message_after_match", message_properties);
                this.setState({
                  new_message: "false",
                });
              }

              this.addMsg({
                chatid: params.chatId,
                sender_id: JSON.parse(localStorage.getItem("session_userid")),
                receiver_id: params.userId,
                transLanguage: JSON.parse(
                  localStorage.getItem("chatTransLang")
                ),
                message: {
                  message: "",
                  upload_image: res.data.imageurl,
                  userName: "",
                  userImage: "",
                  chatTime: curtime,
                  type: "image",
                  id: result.data.id,
                },
              });

              socket.emit("message", {
                chatid: params.chatId,
                sender_id: JSON.parse(localStorage.getItem("session_userid")),
                receiver_id: params.userId,
                transLanguage: JSON.parse(
                  localStorage.getItem("chatTransLang")
                ),
                message: {
                  message: "",
                  upload_image: res.data.imageurl,
                  userName: "",
                  userImage: "",
                  chatTime: curtime,
                  type: "image",
                  id: result.data.id,
                },
              });
            }
          });
        } else {
          this.setState({
            loaderDisplay: false,
          });
          errors["uploadimage"] = res.data.message;
          this.setState({
            errors: errors,
            suc_msg: "errorMsg floatingAlerts1",
          });
          setTimeout(() => {
            this.setState({
              suc_msg: "errorMsghide",
            });
          }, 4000);
        }
      });
    }
  }

  onClearchat() {
    const {
      match: { params },
    } = this.props;
    var clearchat = new FormData();
    clearchat.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    clearchat.set("chat_id", params.chatId);
    clearchat.set("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webclearchat",
      data: clearchat,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      // const message = res.data.message;

      this.props.history.push("/app/Message");
    });
  }

  onDeletemsg() {
    const {
      match: { params },
    } = this.props;

    var id = localStorage.getItem("delete_id");
    var clearchat = new FormData();
    clearchat.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    //clearchat.set('chat_id', params.chatId);
    clearchat.set("delete_id", id);
    axios({
      method: "post",
      url: this.state.api_url + "webdeletemsg",
      data: clearchat,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      this.setState({
        delmsg: false,
      });

      var user_id = JSON.parse(localStorage.getItem("session_userid"));

      // const message = res.data.message;
      const socket = socketIOClient(this.state.endpoint);
      socket.emit("deletemessage", {
        message_id: id,
        deleted_by: user_id,
        delete: 1,
        sender_id: JSON.parse(localStorage.getItem("session_userid")),
        receiver_id: params.userId,
      });

      var tabId = "modal5";
      var tabIds = "modal6";
      var tabIdss = "modal7";

      this.setState({
        [tabId]: false,
        [tabIds]: false,
        [tabIdss]: false,
      });

      const chats = this.state.chats;

      var chat_index = chats.findIndex((x) => x.id == id);

      if (chat_index >= 0) {
        chats[chat_index].delete = 1;
        chats[chat_index].deleted_by = user_id;

        localStorage.removeItem("delete_id");
      }
    });
  }
  onBlock() {
    const {
      match: { params },
    } = this.props;
    var clearchat = new FormData();
    clearchat.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    clearchat.set("block_user_id", params.userId);
    clearchat.set("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webblockchat",
      data: clearchat,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      // const message = res.data.message;
      this.props.history.push("/app/Message");
    });
  }
  boxMouseOverHandler(id) {
    this.setState({
      delmsg: true,
      msgid: id,
      scrollDownFix: true,
    });
  }
  boxMouseLeaveHandler(id) {
    this.setState({
      delmsg: false,
      msgid: 0,
      scrollDownFix: true,
    });
  }
  onUnfriend() {
    //alert("sdsd");
    const {
      match: { params },
    } = this.props;
    var clearchat = new FormData();
    clearchat.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    clearchat.set("unfriend_user_id", params.userId);
    clearchat.set("language", this.state.langKey);
    axios({
      method: "post",
      url: this.state.api_url + "webunfriend",
      data: clearchat,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      //  const message = res.data.message;

      this.props.history.push("/app/Message");
    });
  }
  reportToggle() {
    this.setState((prevState) => ({ dropdownOpen: !prevState.dropdownOpen }));
  }

  render() {
    var style = {
      zIndex: 10,
      backgroundColor: "#fff",
      height: 40,
      width: 40,
      position: "absolute",
      //display:"flex",
      justifyContent: "center",
      alignItems: "center",
      display: this.state.loaderDisplay === true ? "block" : "none",
      overflowY: "hidden",
    };
    var transLangCode;
    if (JSON.parse(localStorage.getItem("chatTransLang"))) {
      transLangCode =
        JSON.parse(localStorage.getItem("chatTransLang")).length === 4
          ? "0"
          : JSON.parse(localStorage.getItem("chatTransLang"));
    } else {
      transLangCode = "0";
    }
    const { t } = this.props;
    const { languageCodes } = this.state;
    //console.log('llllllllllll'+languageCodes);
    let online_status,
      blocked_by_me,
      block_info,
      msg_sec,
      onlinebutton,
      blocked_popup;
    if (this.state.user_details.online === 1 && this.state.block !== "true") {
      online_status = t("Online");
      // lastseen = ''
      onlinebutton = "onlineN3";
    } else if (this.state.block !== "true") {
      // lastseen = 'last seen'
      // online_status = <Moment format="DD MMM YYYY, hh:mm A" unix>{this.state.user_details.timestamp}</Moment>
      online_status = this.state.user_details.onlinelasttime;

      onlinebutton = "";
    }
    if (this.state.blocked_by_me === "true") {
      blocked_by_me = "unblock";
      blocked_popup = "unblockpopup";
      block_info = "Unblock to message";
    } else {
      blocked_by_me = "block";
      if (this.state.block === "true") {
        blocked_by_me = "";
        blocked_popup = "blockpopup";
        block_info = "This User has Blocked you";
      }
    }
    if (this.state.block === "true") {
      msg_sec = (
        <div className="mMessageInputs d-flex">
          <div className="align-self-center flex-fill">
            <input
              class="chat-box-text border-none apd10 width100"
              name="text"
              value={this.state.message}
              placeholder={t("Send Message")}
            ></input>
          </div>

          <div class="align-self-center mr-3 d-flex">
            <div className={this.state.suc_msg}>
              <Trans i18nKey={this.state.errors.uploadimage}>
                {this.state.errors.uploadimage}
              </Trans>
            </div>
          </div>

          <div class="align-self-center">
            <input
              type="button"
              class="send-option border-none"
              name="button"
            />
          </div>
        </div>
      );
    } else {
      msg_sec = (
        <div className="mMessageInputs d-flex">
          <div className="align-self-center flex-fill">
            <input
              class="chat-box-text border-none apd10 width100"
              name="text"
              id="messageinput"
              value={this.state.message}
              onKeyUp={this.handleKeyUp}
              ref="msgInput"
              onChange={this.onChangemessage}
              rows={5}
              maxLength={500}
              placeholder={t("Send Message")}
            ></input>
          </div>

          <div class="align-self-center mr-3 d-flex">
            <form onSubmit={this.onFormSubmit} className="d-flex">
              <div className="loder-icon">
                <div style={style} className="loader_web">
                  <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                </div>
              </div>
              <label for="file-upload" class="attachment-file amg10"></label>
              <input id="file-upload" type="file" onChange={this.onChange} />
            </form>

            <div className={this.state.suc_msg}>
              <Trans i18nKey={this.state.errors.uploadimage}>
                {this.state.errors.uploadimage}
              </Trans>
            </div>
          </div>

          <div class="align-self-center">
            <input
              type="button"
              class="send-option border-none"
              onClick={this.onSendmessage}
              name="button"
            />
          </div>
        </div>
      );
    }
    /*var style = {
            zIndex: 10,
            backgroundColor: "white",
            position: "absolute",
            height: "80vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            //width:"100%",
            overflowY: "hidden"
        };*/

    return (
      <div className="setting-page messageFlex">
        <div className="messageSection">
          <div className="messageSpace messageSpaceH">
            <div className="messagess messagee">
              <div className="media">
                <div className="align-self-center ">
                  <NavLink to="/app/Message">
                    <div className="iconHolder align-self-center mr-1">
                      <div className="backGlow">
                        <div className="backIco"></div>
                      </div>
                    </div>
                  </NavLink>
                </div>

                <div className="align-self-center mx-3 relPos">
                  <NavLink
                    to={`/app/Friends/FriendsNew/${this.state.user_details.user_id}`}
                  >
                    {" "}
                    <img
                      src={this.state.user_details.images}
                      alt=""
                      className="message-profile "
                    />
                  </NavLink>
                  <div class={onlinebutton}></div>
                </div>
                <div className="customSelect">
                  <div className="media-body messages-flex">
                    <div class="d-flex align-items-center">
                      <div className="text-truncate  pointCurs">
                        {this.state.user_details.user_name}
                      </div>
                      {this.state.user_details.face_verification_status &&
                        this.state.user_details.face_verification_status ===
                          true && <div class="verificationIcon"></div>}
                    </div>
                    <div className="messages-overview text-truncate secondaryText">
                      {online_status}
                    </div>
                  </div>

                  <select
                    className="select-language"
                    value={
                      JSON.parse(localStorage.getItem("chatTransLang")) === ""
                        ? "none"
                        : JSON.parse(localStorage.getItem("chatTransLang"))
                    }
                    onChange={(e) => this.changeHandler(e.target.value)}
                  >
                    <option key="none" value="none">
                      {" "}
                      None{" "}
                    </option>
                    {languageCodes.map((lang) => (
                      <option key={lang.language} value={lang.language}>
                        {lang.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="align-self-center ml-1 d-flex">
                  {/*<div className="iconHolder">
                                        <div className="backGlow">
                                            <div className="videoMICo"></div>
                                        </div>
                                    </div>
                                    <div className="iconHolder ml-2">
                                        <div className="backGlow">
                                            <div className="phoneMICo"></div>
                                        </div>
                                    </div>*/}

                  <div className="iconHolder">
                    <div className="backGlow">
                      <Dropdown
                        isOpen={this.state.dropdownOpen}
                        toggle={this.reportToggle}
                      >
                        <DropdownToggle className="RSoverride messageDropdown">
                          <div className="threeDotMenuIcon"></div>
                        </DropdownToggle>
                        <DropdownMenu className="dropDownRSoverride reportDropPos">
                          {blocked_by_me !== "" ? (
                            <div className="apb5 apl15 pointCurs textcapfirst">
                              {" "}
                              <button
                                className="textBtn"
                                onClick={this.showModal.bind(this, "modal1")}
                              >
                                <Trans i18nKey={blocked_by_me}>
                                  {blocked_by_me}
                                </Trans>
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="apb5 apl15 pointCurs">
                            <button
                              className="textBtn"
                              onClick={this.showModal2.bind(this, "modal2")}
                            >
                              {" "}
                              <Trans i18nKey="Clear Chat">Clear Chat</Trans>
                            </button>
                          </div>
                          <div className="apb5 apl15 pointCurs">
                            <button
                              className="textBtn"
                              onClick={this.SafetyLink}
                            >
                              {" "}
                              <Trans i18nKey="Safety Tips">Safety Tips</Trans>
                            </button>
                          </div>
                          <div className="apb5 apl15 pointCurs">
                            <button
                              className="textBtn"
                              onClick={this.showModal3.bind(this, "modal3")}
                            >
                              {" "}
                              <Trans i18nKey="Unfriend">Unfriend</Trans>
                            </button>
                          </div>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mChatbox apd15">
              <div
                className="encryptTips"
                style={{
                  display: this.state.chats.length === 0 ? "block" : "none",
                }}
              >
                <i class="fa fa-lock" aria-hidden="true"></i>
                <Trans i18nKey="Message to this chat and calls are now secured with end-to end encryption.">
                  Message to this chat and calls are now secured with end-to end
                  encryption.
                </Trans>
              </div>
              <div class="blockedInfo">
                <Trans i18nKey={block_info}>{block_info}</Trans>{" "}
              </div>

              {this.state.chats.map((chats, index) =>
                chats.type === "feed" ? (
                  <div
                    className={
                      chats.sender_id ===
                      JSON.parse(localStorage.getItem("session_userid"))
                        ? "mRight mLeft apt5 apb5 d-flex flex-column"
                        : "mLeft apt5 apb5  d-flex flex-column"
                    }
                  >
                    <div
                      className={
                        chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid")) &&
                        chats.delete == 0
                          ? "mRightChat  apd15 align-self-end mb-4"
                          : chats.sender_id ===
                              JSON.parse(
                                localStorage.getItem("session_userid")
                              ) && chats.delete == 1
                          ? "mRightChats apd15 align-self-end mb-4 delMsg"
                          : "mLeftChat apk-14 apd15  align-self-start mb-4"
                      }
                    >
                      <div class="messageImgs">
                        {chats.delete == 1 &&
                        chats.deleted_by ===
                          JSON.parse(localStorage.getItem("session_userid")) ? (
                          <i class="fa fa-ban" aria-hidden="true">
                            {" "}
                            <Trans i18nKey="You deleted this message">
                              You deleted this message
                            </Trans>{" "}
                          </i>
                        ) : chats.delete == 1 &&
                          chats.deleted_by !=
                            JSON.parse(
                              localStorage.getItem("session_userid")
                            ) ? (
                          <i class="fa fa-ban" aria-hidden="true">
                            {" "}
                            This message was deleted{" "}
                          </i>
                        ) : chats.feeds.feed_type === "image" ? (
                          <ImageZoom
                            image={{
                              src: chats.feeds.feed_content
                                ? chats.feeds.feed_content
                                : chats.feeds.feed_content_images[0],
                              alt: "",
                              className: "img w-100 boxShadow borderRdus",
                            }}
                          />
                        ) : (
                          <ImageZoom
                            image={{
                              src:
                                chats.sender_id ===
                                JSON.parse(
                                  localStorage.getItem("session_userid")
                                )
                                  ? this.state.user_details.images
                                  : chats.feeds.feed_content_bacimg,
                              alt: "",
                              className: "img w-100 boxShadow borderRdus",
                            }}
                          />
                        )}
                        {chats.delete == 0 &&
                        chats.feeds.feed_type !== "image" ? (
                          <div class="feedMsgContent pFHidden align-self-center">
                            <div class="text-truncate esmh-14 bold-font">
                              <Trans i18nKey={chats.feeds.feed_type}>
                                {chats.feeds.feed_type}
                              </Trans>
                            </div>
                            <div class="text-truncate bold-font esmh-12">
                              {chats.feeds.feed_content}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {chats.delete == 0 ? (
                          <div class="feedMsgsLiked"></div>
                        ) : (
                          ""
                        )}
                        <div class="feedMsgs">{chats.message}</div>{" "}
                        {chats.delete == 0 &&
                        chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid")) ? (
                          <button
                            className="textBtn"
                            onMouseOver={this.boxMouseOverHandler.bind(
                              this,
                              chats.id
                            )}
                            onMouseLeave={this.boxMouseLeaveHandler.bind(
                              this,
                              chats.id
                            )}
                            onClick={this.showModal5.bind(
                              this,
                              "modal7",
                              chats.id
                            )}
                          >
                            {" "}
                            <button class="textBtn">
                              <span class="message_down_icon"></span>
                            </button>
                          </button>
                        ) : (
                          ""
                        )}
                        {this.state.delmsg == true &&
                        this.state.msgid == chats.id ? (
                          <div class="message_delete_alert">
                            <Trans i18nKey="Delete message">
                              Delete message
                            </Trans>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div
                        className={
                          chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid"))
                            ? "msgTimerFxRight"
                            : "msgTimerFxleft"
                        }
                      >
                        {chats.time}
                      </div>
                    </div>
                  </div>
                ) : chats.upload_image && chats.type !== "gif" ? (
                  <div
                    className={
                      chats.sender_id ===
                      JSON.parse(localStorage.getItem("session_userid"))
                        ? "mRight mLeft apt5 apb5 d-flex flex-column"
                        : "mLeft apt5 apb5  d-flex flex-column"
                    }
                  >
                    <div
                      className={
                        chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid")) &&
                        chats.delete == 0
                          ? "mRightChat  apd15 align-self-end mb-4"
                          : chats.sender_id ===
                              JSON.parse(
                                localStorage.getItem("session_userid")
                              ) && chats.delete == 1
                          ? "mRightChats apd15 align-self-end mb-4 delMsg"
                          : "mLeftChat apk-14 apd15  align-self-start mb-4"
                      }
                    >
                      <div class="messageImgs">
                        {chats.delete == 1 &&
                        chats.deleted_by ===
                          JSON.parse(localStorage.getItem("session_userid")) ? (
                          <i class="fa fa-ban" aria-hidden="true">
                            {" "}
                            <Trans i18nKey="You deleted this message">
                              You deleted this message
                            </Trans>{" "}
                          </i>
                        ) : chats.delete == 1 &&
                          chats.deleted_by !=
                            JSON.parse(
                              localStorage.getItem("session_userid")
                            ) ? (
                          <i class="fa fa-ban" aria-hidden="true">
                            {" "}
                            This message was deleted{" "}
                          </i>
                        ) : (
                          <ImageZoom
                            image={{
                              src: chats.upload_image,
                              alt: "",
                              className: "img w-100 boxShadow borderRdus",
                            }}
                          />
                        )}

                        {chats.delete == 0 &&
                        chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid")) ? (
                          <button
                            className="textBtn"
                            onMouseOver={this.boxMouseOverHandler.bind(
                              this,
                              chats.id
                            )}
                            onMouseLeave={this.boxMouseLeaveHandler.bind(
                              this,
                              chats.id
                            )}
                            onClick={this.showModal5.bind(
                              this,
                              "modal6",
                              chats.id
                            )}
                          >
                            {" "}
                            <button class="textBtn">
                              <span class="message_down_icon"></span>
                            </button>
                          </button>
                        ) : (
                          ""
                        )}

                        {this.state.delmsg == true &&
                        this.state.msgid == chats.id ? (
                          <div class="message_delete_alert">
                            <Trans i18nKey="Delete message">
                              Delete message
                            </Trans>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div
                        className={
                          chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid"))
                            ? "msgTimerFxRight"
                            : "msgTimerFxleft"
                        }
                      >
                        {chats.time}

                        <div
                          className="modal fade apd10"
                          id={
                            "exampleModal-" +
                            chats.upload_image.split("chat/")[1].split(".")[0] +
                            ""
                          }
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="exampleModalLabel"
                          aria-hidden="true"
                        >
                          <div
                            className="modal-dialog vertically-center"
                            role="document"
                          >
                            <div className="modal-content border-radius ">
                              <div className="modal-body profile-page ">
                                <img
                                  class="chatimgdiv"
                                  src={chats.upload_image}
                                  alt="product"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <Modal
                          id={
                            "exampleModal-" +
                            chats.upload_image.split("chat/")[1].split(".")[0] +
                            ""
                          }
                          isOpen={this.state.modal3}
                          toggle={this.closeModal.bind(this, "modal3")}
                          className="premiumPopup vertically-center apd5"
                        >
                          <ModalHeader
                            toggle={this.closeModal.bind(this, "modal3")}
                          >
                            <h4 class="modal-title">
                              <Trans i18nKey="Do you want unfriend this user ?">
                                Do you want unfriend this user ?
                              </Trans>
                            </h4>
                          </ModalHeader>
                          <ModalBody>
                            <div className="modal-body">
                              <div class="d-flex justify-content-end">
                                <div class="mr-3">
                                  <button
                                    class="border-0 bg-white pink-color"
                                    onClick={this.onUnfriend}
                                  >
                                    <Trans i18nKey="Yes">Yes</Trans>
                                  </button>
                                </div>
                                <div>
                                  <button
                                    class="border-0 bg-white"
                                    onClick={this.closeModal.bind(
                                      this,
                                      "modal3"
                                    )}
                                  >
                                    <Trans i18nKey="No">No</Trans>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </ModalBody>
                        </Modal>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className={
                      chats.sender_id ===
                      JSON.parse(localStorage.getItem("session_userid"))
                        ? "mRight mLeft apt5 apb5 d-flex flex-column"
                        : "mLeft apt5 apb5  d-flex flex-column"
                    }
                  >
                    <div
                      className={
                        chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid")) &&
                        chats.delete == 0
                          ? "mRightChat  apd15 align-self-end mb-4"
                          : chats.sender_id ===
                              JSON.parse(
                                localStorage.getItem("session_userid")
                              ) && chats.delete == 1
                          ? "mRightChats apd15 align-self-end mb-4 delMsg"
                          : "mLeftChat apk-14 apd15  align-self-start mb-4"
                      }
                    >
                      <div id="alignsmsg" style={{ display: "flex" }}>
                        {this.state.delmsg == true &&
                        this.state.msgid == chats.id ? (
                          <div class="message_delete_alert">
                            <Trans i18nKey="Delete message">
                              Delete message
                            </Trans>
                          </div>
                        ) : (
                          ""
                        )}

                        {chats.delete === 1 &&
                        chats.deleted_by === this.state.curr_user_id ? (
                          <i class="fa fa-ban" aria-hidden="true">
                            {" "}
                            <Trans i18nKey="You deleted this message">
                              You deleted this message
                            </Trans>{" "}
                          </i>
                        ) : chats.delete == 1 &&
                          chats.deleted_by !== this.state.curr_user_id ? (
                          <i class="fa fa-ban" aria-hidden="true">
                            {" "}
                            This message was deleted{" "}
                          </i>
                        ) : (
                          chats.message
                        )}

                        {chats.delete == 0 &&
                        chats.sender_id ===
                          JSON.parse(localStorage.getItem("session_userid")) ? (
                          <button
                            className="textBtn"
                            style={{ display: "flex" }}
                            onMouseOver={this.boxMouseOverHandler.bind(
                              this,
                              chats.id
                            )}
                            onMouseLeave={this.boxMouseLeaveHandler.bind(
                              this,
                              chats.id
                            )}
                            onClick={this.showModal5.bind(
                              this,
                              "modal5",
                              chats.id
                            )}
                          >
                            {" "}
                            <button class="textBtn">
                              <span class="message_down_icon"></span>
                            </button>
                          </button>
                        ) : (
                          ""
                        )}
                        <br />
                        {chats.sender_id === this.state.curr_user_id ? (
                          ""
                        ) : (
                          <a
                            href="#"
                            style={{
                              display: transLangCode === "0" ? "none" : "block",
                            }}
                            onClick={this.translateChat.bind(
                              this,
                              chats.message,
                              JSON.parse(localStorage.getItem("chatTransLang")),
                              index
                            )}
                          >
                            {chats.delete == 0 ? (
                              <div className="translateImg">
                                <img
                                  src={require("../../assets/img/translatesIcon.png")}
                                  alt="transIcon"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </a>
                        )}
                      </div>
                      <div
                        className={
                          chats.sender_id === this.state.curr_user_id
                            ? "msgTimerFxRight"
                            : "msgTimerFxleft"
                        }
                      >
                        {chats.time}
                      </div>
                    </div>
                  </div>
                )
              )}
              <div
                ref={(el) => {
                  this.messagesEnd = el;
                }}
              >
                {" "}
              </div>
            </div>

            <div class={this.state.loading}>
              <span>
                <Trans i18nKey="Typing">Typing</Trans>
              </span>{" "}
              <span class="blinking">.</span> <span class="blinking1">.</span>{" "}
              <span class="blinking2">.</span>
            </div>

            {msg_sec}
          </div>
        </div>

        <Modal
          isOpen={this.state.modal1}
          toggle={this.closeModal.bind(this, "modal1")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal1")}>
            <h4 class="modal-title">
              <Trans i18nKey="Do you want to block this user ?">
                Do you want to block this user ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.onBlock}
                  >
                    <Trans i18nKey="Yes">
                      <span className="floating-label">Yes</span>{" "}
                    </Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal1")}
                  >
                    <Trans i18nKey="No">
                      <span className="floating-label">No</span>{" "}
                    </Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal2}
          toggle={this.closeModal.bind(this, "modal2")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal2")}>
            <h4 class="modal-title">
              <Trans i18nKey="Do you want to clear chat ?">
                Do you want to clear chat ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.onClearchat}
                  >
                    <Trans i18nKey="Yes">
                      <span className="floating-label">Yes</span>{" "}
                    </Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal2")}
                  >
                    <Trans i18nKey="No">
                      <span className="floating-label">No</span>{" "}
                    </Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal3}
          toggle={this.closeModal.bind(this, "modal3")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal3")}>
            <h4 class="modal-title">
              <Trans i18nKey="Do you want unfriend this user ?">
                Do you want unfriend this user ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.onUnfriend}
                  >
                    <Trans i18nKey="Yes">Yes</Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal3")}
                  >
                    <Trans i18nKey="No">No</Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal5}
          toggle={this.closeModal.bind(this, "modal5")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal5")}>
            <h4 class="modal-title">
              <Trans i18nKey="Are you sure delete this chat ?">
                Are you sure delete this chat ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.onDeletemsg}
                  >
                    <Trans i18nKey="Yes">
                      <span className="floating-label">Yes</span>{" "}
                    </Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal5")}
                  >
                    <Trans i18nKey="No">
                      <span className="floating-label">No</span>{" "}
                    </Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal6}
          toggle={this.closeModal.bind(this, "modal6")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal6")}>
            <h4 class="modal-title">
              <Trans i18nKey="Are you sure delete this image ?">
                Are you sure delete this image ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.onDeletemsg}
                  >
                    <Trans i18nKey="Yes">
                      <span className="floating-label">Yes</span>{" "}
                    </Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal6")}
                  >
                    <Trans i18nKey="No">
                      <span className="floating-label">No</span>{" "}
                    </Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.modal7}
          toggle={this.closeModal.bind(this, "modal7")}
          className="premiumPopup vertically-center apd5"
        >
          <ModalHeader toggle={this.closeModal.bind(this, "modal7")}>
            <h4 class="modal-title">
              <Trans i18nKey="Are you sure delete this feed ?">
                Are you sure delete this feed ?
              </Trans>
            </h4>
          </ModalHeader>
          <ModalBody>
            <div className="modal-body">
              <div class="d-flex justify-content-end">
                <div class="mr-3">
                  <button
                    class="border-0 bg-white pink-color"
                    onClick={this.onDeletemsg}
                  >
                    <Trans i18nKey="Yes">
                      <span className="floating-label">Yes</span>{" "}
                    </Trans>
                  </button>
                </div>
                <div>
                  <button
                    class="border-0 bg-white"
                    onClick={this.closeModal.bind(this, "modal7")}
                  >
                    <Trans i18nKey="No">
                      <span className="floating-label">No</span>{" "}
                    </Trans>
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {/* <Modal isOpen={this.state.modal4} toggle={this.closeModal.bind(this, 'modal4')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal4')}></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                           <div class="d-flex justify-content-end">

                         <img src="{chats.upload_image}"></img>
                           </div>
                        </div>
                    </ModalBody>
                </Modal> */}
      </div>
    );
  }
}

export default withTranslation("translations")(MessageNew);
